import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CachedRequest } from '../models/cache';
import { share, tap } from 'rxjs/operators';

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  private _cache: Map<string, CachedRequest<any>>;
  constructor() {
    this._cache = new Map<string, CachedRequest<any>>();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      //not a GET, don't cache it, unless it's a call to /Acl/HasMinimumRoleByName
      return next.handle(req);
    }
    const header = req.headers.get('X-Cache-Lifetime');
    if (header == null) {
      //header not present. Don't cache.
      return next.handle(req);
    }
    //It's a get, and we have a cache header. Cache it!
    //Start by removing anything expired from the cache.
    this.purgeCache();
    //Now, check the cache to see if it has the value we want!
    if (this._cache.has(req.urlWithParams)) {
      return of(this._cache.get(req.urlWithParams).payload.clone());
    } else {
      //not in cache. Need to tap the observable coming back
      //and add to the cache.
      return next.handle(req).pipe(
        tap(response => {
          //We only want to cache HttpResponses
          if (response instanceof HttpResponse) {
            this._cache.set(req.urlWithParams, new CachedRequest<any>(response.clone(), header));
          }
        }),
        share()
      );
    }
  }

  private purgeCache() {
    const expiredEntries: string[] = [];
    this._cache.forEach((val, key) => {
      if (val.isExpired) {
        expiredEntries.push(key);
      }
    });
    //console.log(expiredEntries);
    expiredEntries.forEach(key => {
      this._cache.delete(key);
    });
  }
}
